// ---------------------------
// Inline SVG icons used in UI
// ---------------------------
const ICONS = {
  email: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z"/></svg>',
  globe: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M415.9 344L225 344C227.9 408.5 242.2 467.9 262.5 511.4C273.9 535.9 286.2 553.2 297.6 563.8C308.8 574.3 316.5 576 320.5 576C324.5 576 332.2 574.3 343.4 563.8C354.8 553.2 367.1 535.8 378.5 511.4C398.8 467.9 413.1 408.5 416 344zM224.9 296L415.8 296C413 231.5 398.7 172.1 378.4 128.6C367 104.2 354.7 86.8 343.3 76.2C332.1 65.7 324.4 64 320.4 64C316.4 64 308.7 65.7 297.5 76.2C286.1 86.8 273.8 104.2 262.4 128.6C242.1 172.1 227.8 231.5 224.9 296zM176.9 296C180.4 210.4 202.5 130.9 234.8 78.7C142.7 111.3 74.9 195.2 65.5 296L176.9 296zM65.5 344C74.9 444.8 142.7 528.7 234.8 561.3C202.5 509.1 180.4 429.6 176.9 344L65.5 344zM463.9 344C460.4 429.6 438.3 509.1 406 561.3C498.1 528.6 565.9 444.8 575.3 344L463.9 344zM575.3 296C565.9 195.2 498.1 111.3 406 78.7C438.3 130.9 460.4 210.4 463.9 296L575.3 296z"/></svg>',
  phone: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M224.2 89C216.3 70.1 195.7 60.1 176.1 65.4L170.6 66.9C106 84.5 50.8 147.1 66.9 223.3C104 398.3 241.7 536 416.7 573.1C493 589.3 555.5 534 573.1 469.4L574.6 463.9C580 444.2 569.9 423.6 551.1 415.8L453.8 375.3C437.3 368.4 418.2 373.2 406.8 387.1L368.2 434.3C297.9 399.4 241.3 341 208.8 269.3L253 233.3C266.9 222 271.6 202.9 264.8 186.3L224.2 89z"/></svg>',
  pin: '<svg width="29" height="36" viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6325 35.1768L13.755 35.2468L13.804 35.2748C13.9983 35.3798 14.2157 35.4348 14.4366 35.4348C14.6575 35.4348 14.8749 35.3798 15.0693 35.2748L15.1182 35.2485L15.2425 35.1768C15.927 34.7709 16.5948 34.3377 17.2445 33.8783C18.9264 32.6908 20.4978 31.3543 21.9398 29.8848C25.3418 26.4023 28.875 21.1698 28.875 14.4375C28.875 10.6084 27.3539 6.9362 24.6464 4.22865C21.9388 1.52109 18.2666 0 14.4375 0C10.6084 0 6.9362 1.52109 4.22865 4.22865C1.52109 6.9362 0 10.6084 0 14.4375C0 21.168 3.535 26.4023 6.93525 29.8848C8.37663 31.3542 9.94748 32.6908 11.6288 33.8783C12.279 34.3378 12.9475 34.7709 13.6325 35.1768ZM14.4375 19.6875C15.8299 19.6875 17.1652 19.1344 18.1498 18.1498C19.1344 17.1652 19.6875 15.8299 19.6875 14.4375C19.6875 13.0451 19.1344 11.7098 18.1498 10.7252C17.1652 9.74062 15.8299 9.1875 14.4375 9.1875C13.0451 9.1875 11.7098 9.74062 10.7252 10.7252C9.74062 11.7098 9.1875 13.0451 9.1875 14.4375C9.1875 15.8299 9.74062 17.1652 10.7252 18.1498C11.7098 19.1344 13.0451 19.6875 14.4375 19.6875Z" fill="url(#paint0_linear_4629_1784)"/><defs><linearGradient id="paint0_linear_4629_1784" x1="14.4375" y1="0" x2="14.4375" y2="35.4348" gradientUnits="userSpaceOnUse"><stop stop-color="#163541"/><stop offset="1" stop-color="#457182"/></linearGradient></defs></svg>',
  calendar: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M224 64C206.3 64 192 78.3 192 96L192 128L160 128C124.7 128 96 156.7 96 192L96 240L544 240L544 192C544 156.7 515.3 128 480 128L448 128L448 96C448 78.3 433.7 64 416 64C398.3 64 384 78.3 384 96L384 128L256 128L256 96C256 78.3 241.7 64 224 64zM96 288L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 288L96 288z"/></svg>',
  arrow: '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="17" fill="none"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m.75.75 7.5 7.5-7.5 7.5"/></svg>',
  close: '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none"><path fill="#0A232D" fill-rule="evenodd" d="M.22.239a.75.75 0 0 1 1.06 0l5.47 5.47 5.47-5.47a.75.75 0 1 1 1.06 1.06l-5.47 5.47 5.47 5.47a.75.75 0 1 1-1.06 1.06l-5.47-5.47-5.47 5.47a.75.75 0 0 1-1.06-1.06l5.47-5.47-5.47-5.47a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"/></svg>',
  closeSmall: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="#FFF" fill-rule="evenodd" d="M9.75 0A9.75 9.75 0 0 0 0 9.75a9.75 9.75 0 0 0 9.75 9.75 9.75 9.75 0 0 0 9.75-9.75A9.75 9.75 0 0 0 9.75 0ZM8.03 6.97a.75.75 0 1 0-1.06 1.06l1.72 1.72-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06l-1.72-1.72 1.72-1.72a.75.75 0 1 0-1.06-1.06L9.75 8.69 8.03 6.97Z" clip-rule="evenodd"/></svg>',
  info: '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none"><path fill="#FFF" fill-rule="evenodd" d="M0 9.75A9.75 9.75 0 0 1 9.75 0a9.75 9.75 0 0 1 9.75 9.75 9.75 9.75 0 0 1-9.75 9.75A9.75 9.75 0 0 1 0 9.75Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM9.75 6.75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd"/></svg>'
};

// ---------------------------
// Shopify JSON file
// ---------------------------
const cacheVersion = Math.floor(Date.now() / 1800000);
const STOCKISTS_JSON_URL = `https://cdn.shopify.com/s/files/1/0565/7283/8048/files/store-locator-data.json?v=${cacheVersion}`;

let STOCKISTS = [];
let FILTERED_STOCKISTS = null;

// ---------------------------
// Global state variables
// ---------------------------
let map, info, bounds, userPoint = null, userMarker = null, activeId = null;
const markers = new Map();

// ---------------------------
// Restructure URL format.
// ---------------------------
function normalizeUrl(url) {
  if (!url || url === '-' ) return '';
  url = url.trim();
  if (/^(javascript:|data:|vbscript:)/i.test(url)) return '';
  if (/^\/\//.test(url)) return 'https:' + url;
  if (/^https:\/\//i.test(url)) return url;
  if (/^http:\/\//i.test(url)) return url.replace(/^http:\/\//i, 'https://');
  return 'https://' + url.replace(/^\/+/, '');
}

// ---------------------------
// Restructure instagram format.
// ---------------------------
function normalizeInstagram(handle) {
  if (!handle || handle === '-') return '';
  handle = handle.trim();
  if (handle.startsWith('@')) handle = handle.slice(1);
  if (/^https?:\/\//i.test(handle)) return handle;
  return 'https://instagram.com/' + handle;
}

// ---------------------------
// Active list item helper (BEM)
// ---------------------------
function setActiveListItem(id) {
  activeId = id;

  document.querySelectorAll('.stockist-locator__list-item--active, .stockist-locator__list-item.active')
    .forEach(el => {
      el.classList.remove('stockist-locator__list-item--active', 'active');
      el.setAttribute('aria-pressed', 'false');
    });

  const el = document.querySelector(`.stockist-locator__list-item[data-id="${id}"]`);
  if (el) {
    el.classList.add('stockist-locator__list-item--active');
    el.setAttribute('aria-pressed', 'true');
    el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }
}

// ---------------------------
// Main initialization: sets up the map, markers, UI listeners
// ---------------------------
async function initMap() {
  await google.maps.importLibrary('maps');
  await google.maps.importLibrary('marker');
  await google.maps.importLibrary('geometry');

  try {
    await loadStockists();
  } catch (e) {
    console.error(e);
    alert('Could not load stockists right now.');
    STOCKISTS = [];
  }

  // Create the map centered roughly on the UK
  map = new google.maps.Map(document.getElementById('map'), {
    center: { lat: 54.6, lng: -5 },
    zoom: 5.6,
    mapId: 'e3e5e4223568266dfbe94c28',
    gestureHandling: 'cooperative',
    disableDefaultUI: true,
    zoomControl: true,
    fullscreenControl: false
  });

  map.getDiv().setAttribute('tabindex', '0');
  info = new google.maps.InfoWindow();
  bounds = new google.maps.LatLngBounds();

  // Create markers for each stockist
  STOCKISTS.forEach((s) => {
    s.pos = new google.maps.LatLng(s.lat, s.lng);

    const pinContainer = document.createElement('div');
    pinContainer.innerHTML = ICONS.pin;
    pinContainer.className = 'stockist-locator__pin';
    pinContainer.dataset.id = s.id;

    const marker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: s.pos,
      title: s.name,
      content: pinContainer
    });

    // Clicking a pin should behave like clicking the list item
    marker.addListener('click', () => focusMarker(s.id));

    markers.set(s.id, marker);
    bounds.extend(s.pos);
  });

  // Wire up "use my location" button
  const useLocBtn = document.getElementById('useMyLocation');
  if (useLocBtn) useLocBtn.addEventListener('click', useMyLocation);

  // Wire up search form
  const searchForm = document.getElementById('searchForm');
  if (searchForm) {
    searchForm.addEventListener('submit', (event) => {
      event.preventDefault();

      const query = String(
        new FormData(searchForm).get('q') ?? ''
      ).trim();

      handleSearch(query);
    });
  }

  refreshList();
}

// ---------------------------
// Open an InfoWindow with details about a stockist
// ---------------------------
function openInfo(s) {
  const wrap = document.createElement('div');
  wrap.className = 'stockist-locator__infobox';

  const title = document.createElement('div');
  title.className = 'stockist-locator__infobox-title';
  title.textContent = s.name;

  const addr = document.createElement('div');
  addr.className = 'stockist-locator__infobox-address';
  addr.textContent = s.address;

  wrap.append(title, addr);

  // Show distance if user location is known
  if (userPoint) {
    const d = document.createElement('div');
    d.className = 'stockist-locator__infobox-distance';
    d.textContent = `${distanceMiles(userPoint, s.pos).toFixed(1)} miles away`;
    wrap.appendChild(d);
  }

  info.setContent(wrap);
  info.open({ anchor: markers.get(s.id), map });
}

// ---------------------------
// Normalise text for searching
// ---------------------------
function normalizeSearchText(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

// ---------------------------
// Search facialist names first,
// then fall back to geocoding
// ---------------------------
function handleSearch(query) {
  if (!query) {
    FILTERED_STOCKISTS = null;
    refreshList();

    if (bounds && !bounds.isEmpty()) {
      map.fitBounds(bounds, 60);
    }

    return;
  }

  const normalizedQuery = normalizeSearchText(query);

  const nameMatches = STOCKISTS.filter((facialist) =>
    normalizeSearchText(facialist.name).includes(normalizedQuery)
  );

  if (nameMatches.length > 0) {
    FILTERED_STOCKISTS = nameMatches;

    // refreshList sorts nearest-first when userPoint exists.
    refreshList();
    fitMapToStockists(nameMatches);

    return;
  }

  // No facialist-name matches, so treat the query as
  // an address, town, city or postcode.
  FILTERED_STOCKISTS = null;
  geocodeAddress(query);
}

// ---------------------------
// Fit the map to matching facialists
// ---------------------------
function fitMapToStockists(stockists) {
  if (!map || !stockists.length) return;

  const searchBounds = new google.maps.LatLngBounds();

  stockists.forEach((stockist) => {
    if (stockist.pos) {
      searchBounds.extend(stockist.pos);
    }
  });

  if (searchBounds.isEmpty()) return;

  map.fitBounds(searchBounds, 60);

  google.maps.event.addListenerOnce(map, 'idle', () => {
    if (map.getZoom() > 15) {
      map.setZoom(15);
    }
  });
}

// ---------------------------
// Look up an address string and set user location
// ---------------------------
function geocodeAddress(query) {
  if (!query) return;
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ address: query, bounds })
    .then(({ results }) => {
      const loc = results?.[0]?.geometry?.location;
      if (!loc) {
        alert('No results found for that address.');
        return;
      }
      setUserPoint(loc);
    })
    .catch((err) => {
      console.error(err);
      alert('There was a problem geocoding that address.');
    });
}

// ---------------------------
// Set the "user location" marker and recenter the map
// ---------------------------
function setUserPoint(latLng) {
  userPoint = latLng;
  FILTERED_STOCKISTS = null;

  // Create or update the custom "you are here" marker
  if (!userMarker) {
    const el = document.createElement('div');
    el.className = 'stockist-locator__user-dot';
    userMarker = new google.maps.marker.AdvancedMarkerElement({
      map,
      position: userPoint,
      title: 'Your location',
      content: el
    });
  } else {
    userMarker.position = userPoint;
  }

  // Center and zoom map on user point
  zoomToShowNearestStore();
  refreshList();
}

// ---------------------------
// Try to get the user's actual location from the browser
// ---------------------------
function useMyLocation() {
  if (!navigator.geolocation) {
    alert('Geolocation not supported');
    return;
  }
  navigator.geolocation.getCurrentPosition(
    (pos) => setUserPoint(new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude)),
    (err) => alert('Could not get your location: ' + err.message),
    { enableHighAccuracy: true, maximumAge: 15000, timeout: 10000 }
  );
}

// ---------------------------
// Rebuild the sidebar list of stockists (sorted by distance if known)
// ---------------------------
function refreshList() {
  const results = document.getElementById('results');
  if (!results) return;

  results.innerHTML = '';

  const sourceStockists =
    FILTERED_STOCKISTS ?? STOCKISTS;

  const items = sourceStockists
    .map((stockist) => ({
      ...stockist,
      dist: userPoint
        ? distanceMiles(userPoint, stockist.pos)
        : null
    }))
    .sort((a, b) => {
      if (a.dist == null || b.dist == null) {
        return a.name.localeCompare(b.name);
      }

      return a.dist - b.dist;
    });

  const fragment = document.createDocumentFragment();

  for (const stockist of items) {
    fragment.appendChild(renderListItem(stockist));
  }

  results.appendChild(fragment);
  scrollResultsToTop();
  hideDetailPanel();
}

// ---------------------------
// Render a single stockist entry in the sidebar list
// ---------------------------
function renderListItem(s) {
  const root = document.createElement('button');
  root.type = 'button';
  root.className = 'stockist-locator__list-item';
  root.dataset.id = s.id;
  root.setAttribute('aria-pressed', 'false');

  if (s.id === activeId) {
    root.classList.add('stockist-locator__list-item--active');
    root.setAttribute('aria-pressed', 'true');
  }

  root.addEventListener('click', () => focusMarker(s.id));

  // Title
  const title = document.createElement('div');
  title.className = 'stockist-locator__list-title';
  title.textContent = `${s.name}`;
  root.appendChild(title);

  // Subtitle (address)
  const subtitle = document.createElement('div');
  subtitle.className = 'stockist-locator__list-subtitle';
  subtitle.textContent = `${s.address}`;
  root.appendChild(subtitle);

  // Distance (if present)
  if (s.dist != null) {
    const d = document.createElement('div');
    d.className = 'stockist-locator__distance';
    d.textContent = `${s.dist.toFixed(1)} miles away`;
    root.appendChild(d);
  }

  // Arrow
  const arrow = document.createElement('div');
  arrow.className = 'stockist-locator__list-arrow';
  arrow.innerHTML = `${ICONS.arrow}`;
  root.appendChild(arrow);

  return root;
}

// ---------------------------
// Focus on a specific stockist marker and open its info
// ---------------------------
function focusMarker(id) {
  const s = STOCKISTS.find(x => x.id === id);
  if (!s) return;

  setActiveListItem(id);

  // Highlight the selected map pin
  document.querySelectorAll('.stockist-locator__pin--active')
    .forEach(el => el.classList.remove('stockist-locator__pin--active'));
  const activePin = document.querySelector(`.stockist-locator__pin[data-id="${id}"]`);
  if (activePin) activePin.classList.add('stockist-locator__pin--active');

  map.panTo(s.pos);
  map.setZoom(Math.min(18, Math.max(5, 15)));

  info.close();
  showDetailPanel(s);
  map.getDiv().focus();
}

// ---------------------------
// Compute distance in miles between two Lat/Lng
// ---------------------------
function distanceMiles(a, b) {
  return google.maps.geometry.spherical.computeDistanceBetween(a, b) / 1609.344;
}

// ---------------------------
// Load facialists from JSON
// ---------------------------
async function loadStockists() {
  const response = await fetch(STOCKISTS_JSON_URL, {
    cache: 'no-store'
  });

  if (!response.ok) {
    throw new Error(
      `Facialist JSON fetch failed: ${response.status}`
    );
  }

  const data = await response.json();

  let rows = Array.isArray(data) ? data : [];

  // Support an optional Make array wrapper
  if (
    rows.length === 1 &&
    Array.isArray(rows[0]?.array)
  ) {
    rows = rows[0].array;
  }

  STOCKISTS = rows
    .map((row, index) => {
      const cells = Array.isArray(row.row_details)
        ? row.row_details
        : [];

      const getCell = (cellIndex) =>
        String(cells[cellIndex]?.content ?? '').trim();

      const name = getCell(0);
      const address = getCell(1);
      const lngString = getCell(2);
      const latString = getCell(3);
      const url = getCell(4);
      const phone = getCell(5);
      const email = getCell(6);
      const instagram = getCell(7);
      const facebook = getCell(8);
      const tiktok = getCell(9);
      const booking = getCell(10);

      const lat = Number(
        latString.replace(',', '.')
      );

      const lng = Number(
        lngString.replace(',', '.')
      );

      if (
        !name ||
        !address ||
        !Number.isFinite(lat) ||
        !Number.isFinite(lng) ||
        lat < -90 ||
        lat > 90 ||
        lng < -180 ||
        lng > 180
      ) {
        console.warn(
          'Skipping invalid facialist row:',
          row
        );

        return null;
      }

      return {
        id: String(
          row.id ??
          row.row_id ??
          index
        ),
        name,
        address,
        lat,
        lng,
        phone,
        email,
        url: normalizeUrl(url),
        instagram: normalizeInstagram(instagram),
        facebook: normalizeUrl(facebook),
        tiktok: normalizeUrl(tiktok),
        booking: normalizeUrl(booking)
      };
    })
    .filter(Boolean);
}

// ---------------------------
// Render store details panel
// ---------------------------
function renderDetailHTML(s) {
  const has = v => v && v !== '-';

  const cleanHost = (href) => {
    try {
      return new URL(href).host;
    } catch {
      return href?.replace(/^https?:\/\//, '') || '';
    }
  };

  const normalizeUkPhone = (phone) => {
    if (!has(phone)) return '';

    const cleaned = String(phone).trim().replace(/(?!^\+)[^\d]/g, '');

    if (!cleaned) return '';

    if (cleaned.startsWith('+44')) return cleaned;
    if (cleaned.startsWith('44')) return `+${cleaned}`;
    if (cleaned.startsWith('0')) return `+44${cleaned.slice(1)}`;
    if (/^\d{10}$/.test(cleaned)) return `+44${cleaned}`;

    return '';
  };

  const isValidUkPhone = (phone) => /^\+44\d{9,10}$/.test(phone);

  const normalizedPhone = normalizeUkPhone(s.phone);
  const telHref = isValidUkPhone(normalizedPhone) ? `tel:${normalizedPhone}` : '';
  const mailHref = has(s.email) ? `mailto:${s.email}` : '';
  const hasSocial = has(s.instagram) || has(s.facebook) || has(s.tiktok);
  const bookingHref = has(s.booking) ? s.booking : (has(s.url) ? s.url : '');

  return `
    <div class="store-detail">
      <div class="store-detail__container">
        <div class="store-detail__header">
          <button type="button" class="store-detail__close" aria-label="Close">${ICONS.close}</button>
        </div>

        <div class="store-detail__hero">
          <h3 class="store-detail__title">${s.name}</h3>
          <div class="store-detail__address">${s.address}</div>
        </div>

        ${bookingHref
          ? `<a class="button button--primary store-detail__cta" href="${bookingHref}" target="_blank" rel="noopener noreferrer">
               Book Now
             </a>`
          : `<button class="button button--primary store-detail__cta" type="button" disabled>
               Book Now
             </button>`
        }

        <div class="store-detail__quick-actions">
          ${telHref
            ? `<a class="button button--secondary" href="${telHref}" aria-label="Call ${s.name}">
                <span class="store-detail__button-icon">${ICONS.phone}</span><span>Call</span>
              </a>`
            : `<button class="button button--secondary" type="button" disabled>
                <span class="store-detail__button-icon">${ICONS.phone}</span><span>Call</span>
              </button>`
          }

          ${has(s.url)
            ? `<a class="button button--secondary" href="${s.url}" target="_blank" rel="noopener noreferrer" aria-label="Website for ${s.name}">
                <span class="store-detail__button-icon">${ICONS.globe}</span><span>Website</span>
              </a>`
            : `<button class="button button--secondary" type="button" disabled>
                <span class="store-detail__button-icon">${ICONS.globe}</span><span>Website</span>
              </button>`
          }

          ${has(s.email)
            ? `<a class="button button--secondary" href="${mailHref}" aria-label="Email ${s.name}">
                <span class="store-detail__button-icon">${ICONS.email}</span><span>Email</span>
              </a>`
            : `<button class="button button--secondary" type="button" disabled>
                <span class="store-detail__button-icon">${ICONS.email}</span><span>Email</span>
              </button>`
          }
        </div>

        <div class="store-detail__section">
          <h4 class="store-detail__section-title h6">Details</h4>

          ${telHref ? `
            <div class="store-detail__row">
              <div class="store-detail__label caption">Phone Number</div>
              <a class="store-detail__value caption" href="${telHref}">${telHref.replace(/^tel:\+44/, '0')}</a>
            </div>` : ''
          }

          ${has(s.url) ? `
            <div class="store-detail__row">
              <div class="store-detail__label caption">Website</div>
              <a class="store-detail__value caption" href="${s.url}" target="_blank" rel="noopener noreferrer">${cleanHost(s.url)}</a>
            </div>` : ''
          }

          ${has(s.email) ? `
            <div class="store-detail__row">
              <div class="store-detail__label caption">Email address</div>
              <a class="store-detail__value caption" href="${mailHref}">${s.email}</a>
            </div>` : ''
          }
        </div>

        ${hasSocial ? `
          <div class="store-detail__section">
            <h4 class="store-detail__section-title h6">Social Media</h4>

            ${has(s.instagram) ? `
              <div class="store-detail__row">
                <div class="store-detail__label caption">Instagram</div>
                <a class="store-detail__value caption" href="${s.instagram}" target="_blank" rel="noopener noreferrer">
                  @${new URL(s.instagram).pathname.replace(/^\/+/, '')}
                </a>
              </div>` : ''
            }

            ${has(s.facebook) ? `
              <div class="store-detail__row">
                <div class="store-detail__label caption">Facebook</div>
                <a class="store-detail__value caption" href="${s.facebook}" target="_blank" rel="noopener noreferrer">
                  ${new URL(s.facebook).hostname.replace(/^www\./, '')}
                </a>
              </div>` : ''
            }

            ${has(s.tiktok) ? `
              <div class="store-detail__row">
                <div class="store-detail__label caption">Tiktok</div>
                <a class="store-detail__value caption" href="${s.tiktok}" target="_blank" rel="noopener noreferrer">
                  ${new URL(s.tiktok).hostname.replace(/^www\./, '')}
                </a>
              </div>` : ''
            }
          </div>` : ''
        }
      </div>
    </div>
  `;
}

// ---------------------------
// Show details panel
// ---------------------------
function showDetailPanel(s) {
  const panel = document.getElementById('storeDetail');
  if (!panel) return;

  panel.innerHTML = renderDetailHTML(s);
  panel.hidden = false;
  panel.setAttribute('aria-hidden', 'false');
  panel.querySelector('.store-detail__close')?.addEventListener('click', hideDetailPanel);

  const onKey = (e) => {
    if (e.key === 'Escape') {
      hideDetailPanel();
    }
  };
  panel.dataset.esc = '1';
  document.addEventListener('keydown', onKey, { once: true });
  updateBodyScrollLock();
  hideNoStoreNearbyMessage();
}

// ---------------------------
// Hide details panel
// ---------------------------
function hideDetailPanel() {
  const panel = document.getElementById('storeDetail');
  if (!panel) return;
  panel.hidden = true;
  panel.setAttribute('aria-hidden', 'true');
  updateBodyScrollLock();
}

// ---------------------------
// Scroll results to top
// ---------------------------
function scrollResultsToTop() {
  const results = document.getElementById('results');
  const scroller = results?.closest('.stockist-locator__sidebar-inner') || results;
  if (!scroller) return;

  requestAnimationFrame(() => {
    scroller.scrollTop = 0;
  });
}

// ---------------------------
// Toggle sidebar visibility
// ---------------------------
const toggleListBtn = document.querySelector('.stockist-locator__toggle-list');
const sidebar = document.querySelector('.stockist-locator__sidebar');

if (toggleListBtn && sidebar) {
  toggleListBtn.addEventListener('click', () => {
    sidebar.parentElement.classList.toggle('active');
    toggleListBtn.classList.toggle('active');

    const isActive = sidebar.parentElement.classList.contains('active');
    toggleListBtn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    sidebar.scrollIntoView({ behavior: 'auto', block: `${isActive ? 'start' : 'end'}` });
  });
}

// ---------------------------
// Body scroll lock on mobile
// ---------------------------
function updateBodyScrollLock() {
  const detailOpen = (() => {
    const el = document.getElementById('storeDetail');
    return el ? el.hidden === false : false;
  })();
  document.body.classList.toggle('no-scroll', !!(detailOpen));
}

// ---------------------------
// Get nearest N stores
// ---------------------------
function getNearestStores(count = 3) {
  if (!userPoint || !STOCKISTS.length) return [];

  return STOCKISTS
    .filter(s => s.pos)
    .map(s => ({
      ...s,
      distanceMeters: google.maps.geometry.spherical.computeDistanceBetween(userPoint, s.pos)
    }))
    .sort((a, b) => a.distanceMeters - b.distanceMeters)
    .slice(0, count);
}

// ---------------------------
// Zoom to show nearest store
// ---------------------------
function zoomToShowNearestStore() {
  if (!map || !userPoint) return;

  const nearestStores = getNearestStores(3);
  if (!nearestStores.length) return;

  const nearestDistanceKm = nearestStores[0].distanceMeters / 1000;

  // Optional: keep your "no nearby store" message logic based on nearest store
  if (nearestDistanceKm > 5) {
    showNoStoreNearbyMessage();
  } else {
    hideNoStoreNearbyMessage();
  }

  // Fit bounds to user point + nearest 3 stores
  const b = new google.maps.LatLngBounds();
  b.extend(userPoint);

  nearestStores.forEach(store => {
    b.extend(store.pos);
  });

  map.fitBounds(b, 60); // padding in px

  google.maps.event.addListenerOnce(map, 'idle', () => {
    const z = map.getZoom();
    const minZoom = 5;
    const maxZoom = 16;

    if (z < minZoom) map.setZoom(minZoom);
    if (z > maxZoom) map.setZoom(maxZoom);
  });
}

// ---------------------------
// Get nearest store
// ---------------------------
function getNearestStore() {
  if (!userPoint || !STOCKISTS.length) return null;

  let nearest = null;
  let nearestDist = Infinity;

  for (const s of STOCKISTS) {
    if (!s.pos) continue;
    const d = google.maps.geometry.spherical.computeDistanceBetween(userPoint, s.pos);
    if (d < nearestDist) {
      nearestDist = d;
      nearest = s;
    }
  }

  if (!nearest) return null;
  return { store: nearest, distanceMeters: nearestDist };
}

// ---------------------------
// Show no store nearby message
// ---------------------------
function showNoStoreNearbyMessage() {
  const el = document.getElementById('noStoreMessage');
  if (!el) return;
  el.innerHTML = `
    ${ICONS.info}
    ${window.labels.noStoreMessage}
    <button class="button--plain" type="button" onclick="hideNoStoreNearbyMessage()">
      ${ICONS.closeSmall}
    </button>
  `;
  el.hidden = false;
}

// ---------------------------
// Hide no store nearby message
// ---------------------------
function hideNoStoreNearbyMessage() {
  const el = document.getElementById('noStoreMessage');
  if (!el) return;
  el.hidden = true;
}

// ---------------------------
// Initialize map
// ---------------------------
window.initMap = initMap;